<div class="container-create-one-to-one">
  <app-state [state]="state">
    <ng-container *ngIf="!state.loading && !state.error">
      <div class="card no-margin">
        <div class="content">
          <div class="p-bottom-15">
            <h1 class="standard-heading" translate>{{state.editing ? eOneToOneMessages.EDIT_SCHEDULE : eOneToOneMessages.CREATE_SCHEDULE}}</h1>
          </div>

          <!-- Global details -->
          <div class="card content" [class.card-offwhite]="!isScheduleManager">
            <div class="p-bottom-15">
              <h4 class="standard-heading" translate>{{eOneToOneMessages.GLOBAL_DETAILS}}</h4>
              <div class="standard-description" translate>{{eOneToOneMessages.GLOBAL_DETAILS_DESCRIPTION}}</div>
            </div>

            <!-- Participants -->
            <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown" [class.frankli-form-group-invalid]="state.submitted && controlScheduleParticipants.invalid">
              <label for="participants" translate>{{eOneToOneMessages.PARTICIPANT}}</label>
              <app-user-picker id="participants" [formControl]="controlScheduleParticipants" [canSelectMultiple]="true" [searchPlaceholder]="eOneToOneMessages.CREATE_SEARCH_PLACEHOLDER" [signedUpUsersOnly]="true" [loseFocusAfterSelection]="false"></app-user-picker>
              <div class="frankli-form-group-alert">
                <ng-container *ngIf="state.submitted && controlScheduleParticipants.invalid">
                  <div *ngIf="controlScheduleParticipants.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                  <div *ngIf="controlScheduleParticipants.hasError('maxlength')" translate>Cannot have more than 10 participants</div>
                </ng-container>
              </div>
            </div>
  
            <!-- Purpose -->
            <div class="frankli-form-group" [class.frankli-form-group-filled]="controlPurpose.value" [class.frankli-form-group-invalid]="state.submitted && controlPurpose.invalid">
              <label for="purpose" translate>{{eOneToOneMessages.PURPOSE}}</label>
              <input type="text" id="purpose" class="form-control" [placeholder]="eOneToOneMessages.CREATE_PURPOSE_PLACEHOLDER | translate" [formControl]="controlPurpose">
              <div class="frankli-form-group-alert">
                <ng-container *ngIf="state.submitted && controlPurpose.invalid">
                  <div *ngIf="controlPurpose.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                  <div *ngIf="controlPurpose.hasError('maxlength')" translate [translateParams]="{ minCharacters: 1, maxCharacters: 255 }">{{eCommonMessages.FORM_CHARACTER_LENGTH_BETWEEN}}</div>
                </ng-container>
              </div>
            </div>
  
            <!-- Linked Evaluation Cycle -->
            <div class="area-schedule-linking-controls">
              <ng-container *ngIf="canSelectEvaluationCycle && dataEvaluationCycles.length > 0">
                <div class="frankli-form-group frankli-form-group-filled">
                  <label for="linked-cycle" translate>{{eOneToOneMessages.REVIEW_CYCLE}}</label>
                  <select class="form-control" id="linked-cycle" [formControl]="controlLinkedEvaluationCycle">
                    <option [ngValue]="null" translate>{{eOneToOneMessages.NOT_LINKED}}</option>
                    <ng-container *ngFor="let cycle of dataEvaluationCycles">
                      <option [ngValue]="cycle.id">
                        <span>{{cycle.name}} ({{cycle.periodStart | momentPipe: 'MMM YY'}} - {{cycle.periodEnd | momentPipe: 'MMM YY'}})</span>
                      </option>
                    </ng-container>
                  </select>
                  <div class="frankli-form-group-alert">
                    <ng-container *ngIf="state.submitted && controlLinkedEvaluationCycle.invalid">
                      <div *ngIf="controlLinkedEvaluationCycle.hasError('notUnique')" translate [translateParams]="{ participantFirstName: controlScheduleParticipants.value.firstName }">{{eOneToOneMessages.ALREADY_EXISTS_FOR_CYCLE}}</div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
  
            <!-- Location type and location detials -->
            <div class="area-location-controls">
              <!-- Location Type -->
              <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown" [class.frankli-form-group-invalid]="state.submitted && controlLocationType.invalid">
                <label for="location-type" translate>{{eOneToOneMessages.LOCATION_TYPE}}</label>
                <select id="location-type" class="form-control" [formControl]="controlLocationType">
                  <option [ngValue]="null" *ngIf="!controlLocationType.value" translate>{{eCommonMessages.SELECT_PROMPT}}</option>
                  <option *ngFor="let locationType of dataLocationTypes" [ngValue]="locationType" translate>{{formatOption(locationType)}}</option>
                </select>
                <div class="frankli-form-group-alert">
                  <ng-container *ngIf="state.submitted && controlLocationType.invalid">
                    <div *ngIf="controlLocationType.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                  </ng-container>
                </div>
              </div>
  
              <!-- Location details -->
              <ng-container *ngIf="controlLocationType.value !== null">
                <div class="area-location-details-control">
                  <div class="location-dash">-</div>
    
                  <ng-container *ngIf="autoCreatingLocationDetails; else regularLocationDetails">
                    <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown">
                      <label for="location-details">
                        <span translate>{{eOneToOneMessages.LOCATION_DETAILS}}</span>
                        <span class="m-right-5"></span>
                        <span>({{eCommonMessages.OPTIONAL | translate}})</span>
                      </label>
                      <div class="display-auto-generated-link-control" id="location-details">
                        <span translate>{{eOneToOneMessages.GENERATED_LINK}}</span>
                        <span class="m-right-10"></span>
                        <a class="prompt-manually-generate-link" (click)="setGoogleLinkManually()" translate>{{eOneToOneMessages.MANUAL_LINK}}</a>
                      </div>
                      <div class="frankli-form-group-alert">
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #regularLocationDetails>
                    <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown" [class.frankli-form-group-invalid]="state.submitted && controlLocation.invalid">
                      <label for="location-details">
                        <span translate>{{eOneToOneMessages.LOCATION_DETAILS}}</span>
                        <ng-container *ngIf="controlLocationType.value !== eScheduleLocationType.OTHER"> 
                          <span class="m-right-5" ></span>
                          <span>({{eCommonMessages.OPTIONAL | translate}})</span>
                        </ng-container>
                      </label>
                      <input id="location-details" type="text" [placeholder]="locationPlaceholder" [formControl]="controlLocation" class="form-control">
                      <div class="frankli-form-group-alert">
                        <ng-container *ngIf="state.submitted && controlLocation.invalid">
                          <div *ngIf="controlLocation.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                          <div *ngIf="controlLocation.hasError('maxlength')" translate [translateParams]="{ minCharacters: 1, maxCharacters: 2000 }">{{eCommonMessages.FORM_CHARACTER_LENGTH_BETWEEN}}</div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </ng-container>
            </div>
  
            <!-- Meeting length, frequency, timezone -->
            <div class="area-scheduling-controls">
              <div class="area-scheduling-controls-main">
                <!-- Meeting length -->
                <div class="frankli-form-group frankli-form-group-filled">
                  <label for="meeting-length" translate>{{eOneToOneMessages.MEETING_LENGTH}}</label>
                  <select class="form-control" id="meeting-length" [formControl]="controlMeetingLength">
                    <option [value]="eOneToOneMeetingLength.FIFTEEN_MINUTES" translate>{{eOneToOneMessages.MEETING_LENGTH_15_MINUTES}}</option>
                    <option [value]="eOneToOneMeetingLength.THIRTY_MINUTES" translate>{{eOneToOneMessages.MEETING_LENGTH_30_MINUTES}}</option>
                    <option [value]="eOneToOneMeetingLength.FORTY_FIVE_MINUTES" translate>{{eOneToOneMessages.MEETING_LENGTH_45_MINUTES}}</option>
                    <option [value]="eOneToOneMeetingLength.SIXTY_MINUTES" translate>{{eOneToOneMessages.MEETING_LENGTH_60_MINUTES}}</option>
                  </select>
                  <div class="frankli-form-group-alert"></div>
                </div>
  
                <!-- Frequency -->
                <div class="frankli-form-group frankli-form-group-filled" [class.frankli-form-group-invalid]="state.submitted && controlFrequency.invalid">
                  <label for="frequency" translate>{{eOneToOneMessages.FREQUENCY}}</label>
                  <select class="form-control" id="frequency" [formControl]="controlFrequency">
                    <option *ngFor="let frequency of dataFrequencies" [ngValue]="frequency" translate>{{frequency}}</option>
                  </select>
                  <ng-container *ngIf="shouldExplainFrequency">
                    <div class="area-frequency-explanation" [ngSwitch]="controlFrequency.value">
                      <div *ngSwitchCase="eOneToOneFrequency.Monthly" translate [translateParams]="{ dateInMonth: getMonthlyText() }">{{eOneToOneMessages.MONTHLY_WARNING}}</div>
                      <div *ngSwitchCase="eOneToOneFrequency.Quarterly" translate [translateParams]="{ dateInQuarter: getMonthlyText() }">{{eOneToOneMessages.QUARTERLY_WARNING}}</div>
                    </div>
                  </ng-container>
                  <div class="frankli-form-group-alert">
                    <ng-container *ngIf="state.submitted && controlFrequency.invalid">
                      <div *ngIf="controlFrequency.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                    </ng-container>
                  </div>
                </div>

                <!-- Timezone -->
                <div class="frankli-form-group frankli-form-group-filled" [class.frankli-form-group-invalid]="state.submitted && controlTimezone.invalid">
                  <label for="timezone">Timezone</label>
                  <input id="timezone" class="form-control timezone-input-real" [formControl]="controlTimezone" [typeahead]="dataTimezones" [typeaheadItemTemplate]="templateTimezoneOption" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="5" [typeaheadMinLength]="1" (click)="onClickTimezoneInput()">
                  <ng-template #templateTimezoneOption let-model="item" let-index="index">
                    <div>{{model | underscoreToSpace}}</div>
                  </ng-template>
                  <div class="frankli-form-group-alert">
                    <ng-container *ngIf="controlTimezone.invalid && state.submitted">
                      <div *ngIf="controlTimezone.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                      <div *ngIf="controlTimezone.hasError('isoneof')" translate>{{eAdminMessages.SITES.TIME_ZONE_INVALID}}</div>
                    </ng-container>
                  </div>
                </div>  
              </div>

              <!-- Custom frequency-->
              <ng-container *ngIf="controlFrequency.value === eOneToOneFrequency.Custom">
                <div class="card content no-margin">
                  <div class="p-bottom-15">
                    <h5 class="standard-heading">Custom frequency details</h5>
                  </div>
                  <app-custom-frequency id="recurring-rule" [formControl]="controlRecurringRule" [meetingTime]="controlMeetingTime.value" [submitted]="state.submitted" (customFrequencyChange)="onCustomFrequencyChange($event)"></app-custom-frequency>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Meeting details -->
          <div class="card content">
            <div class="p-bottom-15">
              <h4 class="standard-heading" translate>{{eOneToOneMessages.MEETING_SPECIFIC_DETAILS}}</h4>
              <div class="standard-description" translate>{{eOneToOneMessages.MEETING_SPECIFIC_DETAILS_DESCRIPTION}}</div>
            </div>

            <!-- Just next meeting checkbox -->
            <ng-container *ngIf="state.editing && showJustNextMeetingCheckbox">
              <div class="p-bottom-15">
                <div class="p-bottom-15">
                  <div class="standard-description" translate>{{eOneToOneMessages.JUST_NEXT_MEETING_EXPLANATION}}</div>
                </div>
                <app-button-group [formControl]="controlJustNextMeeting" [options]="optionsJustNextMeeting" [style]="'dark'"></app-button-group>
              </div>

              <hr/>
            </ng-container>
  
            <ng-container *ngIf="controlFrequency.value !== eOneToOneFrequency.Flexible">
              <div class="area-scheduling-controls-shared">
                <!-- Meeting time -->
                <div class="frankli-form-group frankli-form-group-filled" [class.frankli-form-group-invalid]="state.submitted && controlMeetingTime.invalid">
                  <label for="meeting-time">
                    <span translate>{{eOneToOneMessages.MEETING_TIME}}</span>
                    <ng-container *ngIf="controlJustNextMeeting.value === false">
                      <span class="m-right-5"></span>
                      <span class="fal fa-fw fa-info-circle" container="body" [triggers]="globals.tooltipTriggers" [tooltip]="'The latest meeting will be rescheduled to this time and any future meetings will be scheduled based on this date and the frequency selected above'"></span>
                    </ng-container>
                  </label>
                  <ng-container *ngIf="!state.datepickerLoading">
                    <div (click)="tryShowAvailabilityPopup($event)">
                      <div class="wrapper-date-picker" [class.wrapper-date-picker-use-availability]="shouldUseAvailabilityPicker">
                        <app-date-picker-old-component id="meeting-time" [minDate]="minDate" [maxDate]="maxDate" [sideBySide]="true" [verticalPosition]="'top'" [horizontalPosition]="'left'" [formControl]="controlMeetingTime" [format]="'YYYY-MM-DD HH:mm'" [displayFormat]="'HH:mm ddd, D MMM YYYY'" [disabled]="schedule && schedule.status === 'PAUSED'" [emptyText]="eOneToOneMessages.MEETING_TIME_EMPTY | translate" [viewMode]="'no-reset'"></app-date-picker-old-component>
                      </div>
                    </div>
                  </ng-container>
                  <div class="frankli-form-group-alert">
                    <ng-container *ngIf="state.submitted && controlMeetingTime.invalid">
                      <div *ngIf="controlMeetingTime.hasError('required')" translate>{{eCommonMessages.FORM_REQUIRED}}</div>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="controlJustNextMeeting.value === false">
                  </ng-container>
                </div>
              </div>
            </ng-container>
            
            <!-- Talking points -->
            <div class="area-talking-points">
              <div class="area-talking-points-heading">
                <h4 class="standard-heading">
                  <span translate>{{eOneToOneMessages.RECURRING_TALKING_POINTS}}</span>
                  <ng-container *ngIf="!state.editing">
                    <span class="m-right-5"></span>
                    <span>({{eCommonMessages.OPTIONAL | translate}})</span>
                  </ng-container>
                </h4>
                <div class="area-template-actions">
                  <app-button [small]="true" [type]="eButtonType.GREEN_INVERTED" [tooltipText]="eOneToOneMessages.CHOOSE_TEMPLATE_TOOLTIP | translate" (onClick)="showTalkingPointTemplates()">
                    <span translate>{{eOneToOneMessages.CHOOSE_TEMPLATE}}</span>
                  </app-button>
                  <app-button [small]="true" [type]="eButtonType.GRAY_INVERTED" [tooltipText]="eOneToOneMessages.CLEAR_ALL_TOOLTIP | translate" (onClick)="clearTalkingPoints()">
                    <span translate>{{eOneToOneMessages.CLEAR_ALL}}</span>
                  </app-button>
                </div>
              </div>
  
              <app-talking-points [talkingPoints]="controlTalkingPointsRecurring.value" [displayComments]="false" (changeEvent)="onTalkingPointsChanged($event)" [canReorder]="true" [creatingSchedule]="true" [schedule]="scheduleEditing"></app-talking-points>
            </div>
          </div>

          <!-- Sentiment scale options -->
          <ng-container *ngIf="showSentimentScaleOptions">
            <div class="card content" [class.card-offwhite]="!isScheduleManager">
              <div class="area-sentiment-scale">
                <div class="area-sentiment-scale-heading">
                  <div class="area-sentiment-scale-heading-left">
                    <h4 class="standard-heading">
                      <span translate>{{eOneToOneMessages.SENTIMENT_SCALE}}</span>
                      <span class="m-right-5"></span>
                      <span>({{eCommonMessages.OPTIONAL | translate}})</span>
                    </h4>
                    <div class="standard-description" translate>{{eOneToOneMessages.SENTIMENT_SCALE_DESCRIPTION}}</div>
                  </div>
  
                  <app-slider-input [formControl]="controlHasSentimentScale"></app-slider-input>
                </div>
  
                <ng-container *ngIf="controlHasSentimentScale.value">
                  <ng-container *ngIf="dataSentimentScales.length > 0; else templateEmptyStateSentimentScales;">
                    <ng-container *ngIf="state.editing">
                      <div class="card card-yellow m-top-15 no-margin">
                        <div class="content">
                          <span class="fal fa-fw fa-triangle-exclamation m-right-15"></span>
                          <span class="d-inline-block">If the sentiment scale is changed, any response to it in the currently scheduled meeting will be lost</span>
                        </div>
                      </div>
                    </ng-container>
  
                    <div class="frankli-form-group p-top-15">
                      <select class="form-control" id="sentiment-scale" [formControl]="controlSentimentScaleId">
                        <option [ngValue]="null" translate>{{eCommonMessages.SELECT_PROMPT}}</option>
                        <ng-container *ngFor="let sentimentScaleOption of dataSentimentScales">
                          <option [ngValue]="sentimentScaleOption.id" translate>{{sentimentScaleOption.name}}</option>
                        </ng-container>
                      </select>
                      <div class="frankli-form-group-alert"></div>
                    </div>
                  </ng-container>
  
                  <ng-template #templateEmptyStateSentimentScales>
                    <app-empty-state [height]="'100px'" [message]="eSentimentScaleMessages.MEETING_SENTIMENT_EMPTY_STATE"></app-empty-state>
                  </ng-template>
                </ng-container>
  
                <ng-container *ngIf="controlSentimentScaleId.value && selectedSentimentScaleObject">
                  <app-frame-with-heading [title]="eCommonMessages.PREVIEW">
                    <app-sentiment-scale-response [sentimentScale]="selectedSentimentScaleObject" [disabled]="true"></app-sentiment-scale-response>
                  </app-frame-with-heading>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>

        <hr class="m-top-0 m-bottom-0"/>

        <div class="area-action-buttons">
          <app-button (onClick)="cancelCreate()" [type]="eButtonType.GREEN_INVERTED">{{eCommonMessages.CANCEL | translate}}</app-button>
          <app-button [loading]="state.submitting" (onClick)="onClickSave()" [type]="eButtonType.GREEN">{{eCommonMessages.CONFIRM | translate}}</app-button>
        </div>
      </div>
  
      <app-template-modal #componentTalkingPointTemplates [talkingPoints]="controlTalkingPointsRecurring.value" [isSecondaryManager]="canSeeSecondaryManagerTalkingPoints" (onSelectTemplate)="onSelectTemplateFromRecommended($event)"></app-template-modal>
      <ng-container *ngIf="calendarConnectionStatus && calendarConnectionStatus.connected">
        <app-availability-modal #availabilityModal [otherUsers]="controlScheduleParticipants.value" [timezone]="controlTimezone.value | spaceToUnderscore" [meetingTime]="controlMeetingTime.value" [meetingLength]="controlMeetingLength.value" (meetingTimeChanges)="availabilityTimeChanged($event)" (meetingLengthChanges)="availabilityLengthChanged($event)"></app-availability-modal>
      </ng-container>
    </ng-container>
  </app-state>
</div>
